// External Libraries
import cloneDeep from 'lodash/cloneDeep';

// Saga Utility Functions
import { successFor, failedFor } from '../../sagaUtil';

// App and action Constants
import { BUDGET_CONSTANTS, APPLICATION_CONSTANTS } from 'AppConstants';
import { BUDGET_STORE_CONSTANTS } from '../../actionConstants';

// Budget Management Config
import { filters } from '../../../budgetManagement/config';

// Utility Functions
import { handleSelected as handleBudgetSelected, resetBudgetFilterValues } from 'UtilityComponents/budgetUtils';



const initialBudgetList = {
	data: [],
	error: false,
	loading: false,
	hasMore: false
};

export const INITIAL_STATE = {
	budgetList: initialBudgetList,          // no need to clone every time
	selectedRecords: {},
	list: [],
	filters: cloneDeep(filters),
	query: cloneDeep(filters),
	pageLimit: BUDGET_CONSTANTS.DETAILS_PAGE_LIMIT * 6,
	pageNo: BUDGET_CONSTANTS.PAGE_NO,
	isAllSelected: false,
	searchCount: 0,
	apiStatus: '',
};

export default function budgetReducer(state = cloneDeep(INITIAL_STATE), action) {

	if (!action) return state;

	const { type, payload } = action;
	switch (type) {

		// SET BUDGET LISTING
		case BUDGET_STORE_CONSTANTS.SET_BUDGET_LISTING: {
			const { data = {} } = payload || {};
			return {
				...state,
				budgetList: { data: data?.res_data?.budget_details || [], error: false, loading: false, apiStatus: true },
				budgetStats: { data: data?.res_data?.budget_stats }
			};
		}

		// UPDATE SELECTED BUDGETS
		case BUDGET_STORE_CONSTANTS.UPDATE_BUDGET_SELECTED: {
			const { selectedList } = handleBudgetSelected(
				state.selectedRecords,
				payload
			);

			const { selectAll, checked } = payload;

			return {
				...state,
				selectedRecords: cloneDeep(selectedList),
				isAllSelected: !!(selectAll && checked)
			};
		}

		// UPDATE FILTER QUERY
		case BUDGET_STORE_CONSTANTS.BUDGET_FILTER_QUERY: {
			const updatedFilter = payload?.updatedFilter
				? cloneDeep(payload.updatedFilter)
				: cloneDeep(state.filters);

			return {
				...state,
				filters: updatedFilter,
				budgetList: initialBudgetList,
				pageNo: 1
			};
		}
		case BUDGET_STORE_CONSTANTS.BUDGET_FILTER_CLEAR: {
			return {
				...state,
				filters: resetBudgetFilterValues(state.filters),
				budgetList: initialBudgetList,
				pageNo: 1
			};
		}
		case BUDGET_STORE_CONSTANTS.LIST_API_LOADING: {
			const { loading = true, apiType = '', data } = payload || {};
			return {
				...state,
				apiType,
				msgData: data,
				apiStatus: loading ? APPLICATION_CONSTANTS.LOADING : ''
			};
		}
		case failedFor(BUDGET_STORE_CONSTANTS.LIST_API_ERROR): {
			const { apiType = '', data, showNotify = false } = payload || {};
			return {
				...state,
				apiType,
				msgData: data,
				apiStatus: APPLICATION_CONSTANTS.FAILED,
				showNotify
			};
		}
		case successFor(BUDGET_STORE_CONSTANTS.LIST_API_SUCCESS): {
			const { data, apiType = '', showNotify = false } = payload;
			return {
				...state,
				msgData: data,
				apiType,
				apiStatus: APPLICATION_CONSTANTS.SUCCESS,
				showNotify
			};
		}
		case BUDGET_STORE_CONSTANTS.SET_MODAL: {

			return {
				...state,
				exportSuccessMessage: payload?.modalMsg,
			};
		}

		// DEFAULT RETURN
		default:
			return state;
	}
}
